import React from "react";
import { Navigate } from "react-router-dom";


const ProtectedRoute = ({ children }) => {
  // Check for both accessToken and authToken in both storages
  const accessToken = localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  const authToken = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  const hasToken = (accessToken && accessToken !== "null") || (authToken && authToken !== "null");

  if (!hasToken) {
    // If token is missing or invalid, redirect to login page
    return <Navigate to="/" replace />;
  }

  // If token exists, allow access to the requested page
  return children;
};

export default ProtectedRoute;
